import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath } from '../../../constants/defaultValues';
import { TID_LIST, TID_ADD, TID_FILTER_TASK_STATUS, TID_FILTER_SUPPLIERS, TID_FILTER_DESTINATIONS } from '../../actions';
import { TaskInspectionDestinationListSuccess, TaskInspectionDestinationListError, TaskInspectionDestinationAddSuccess, TaskInspectionDestinationAddError, TaskInspectionDestinationFilterTaskStatusSuccess, TaskInspectionDestinationFilterSuppliersSuccess, TaskInspectionDestinationFilterDestinationsSuccess } from '../../actions';

function getToken(auth) {
  return new Promise((resolve, reject) => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      user.getIdToken().then((token) => { unsubscribe(); resolve(token); });
    }, reject);
  });
}

const onListAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/task_inspection_destination/list', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onAddAsync = async (payload) => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'delivery_plan/task_inspection_destination/add', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify(payload)
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onFilterTaskStatusAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/task_status', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onFilterSuppliersAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/suppliers', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

const onFilterDestinationsAsync = async () => {
  let token = await getToken(authFB);
  const response = await fetch(servicePath + 'search/delivery_plan/destinations', {
    method: 'POST', mode: 'cors', cache: 'no-cache',
    headers: { 'Content-Type': 'application/json', 'token': token },
    body: JSON.stringify({})
  }).then(r => r.json()).catch(err => console.log(err));
  return { data: response };
};

function* onList(data) {
  try { const response = yield call(onListAsync, data.payload); yield put(TaskInspectionDestinationListSuccess(response.data)); }
  catch (error) { yield put(TaskInspectionDestinationListError(error)); }
}

function* onAdd(data) {
  try { const response = yield call(onAddAsync, data.payload); yield put(TaskInspectionDestinationAddSuccess(response.data)); }
  catch (error) { yield put(TaskInspectionDestinationAddError(error)); }
}

function* onFilterTaskStatus() {
  try { const response = yield call(onFilterTaskStatusAsync); yield put(TaskInspectionDestinationFilterTaskStatusSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

function* onFilterSuppliers() {
  try { const response = yield call(onFilterSuppliersAsync); yield put(TaskInspectionDestinationFilterSuppliersSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

function* onFilterDestinations() {
  try { const response = yield call(onFilterDestinationsAsync); yield put(TaskInspectionDestinationFilterDestinationsSuccess(response.data.data || [])); }
  catch (error) { console.error(error); }
}

export function* watchList() { yield takeEvery(TID_LIST, onList); }
export function* watchAdd() { yield takeEvery(TID_ADD, onAdd); }
export function* watchFilterTaskStatus() { yield takeEvery(TID_FILTER_TASK_STATUS, onFilterTaskStatus); }
export function* watchFilterSuppliers() { yield takeEvery(TID_FILTER_SUPPLIERS, onFilterSuppliers); }
export function* watchFilterDestinations() { yield takeEvery(TID_FILTER_DESTINATIONS, onFilterDestinations); }

export default function* rootSaga() {
  yield all([fork(watchList), fork(watchAdd), fork(watchFilterTaskStatus), fork(watchFilterSuppliers), fork(watchFilterDestinations)]);
}
